import { configureStore } from '@reduxjs/toolkit'
import { rootReducer } from './reducers'
import { logger, thunk } from '../middleware'

export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk, logger],
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
